(function () {
  'use strict';

  angular
      .module('tfc.retailer.Brand', [])
      .constant('BrandReportKeys', ['BrandAffinity'])
      .constant('BrandAffinityTimeFrames', ['Last3Months', 'LastYear'])
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('brandReports', {
          abstract : true,
          parent : 'pageWithMenu',
          url : '/brand',
          data : {
            // TODO: This will change once we figure out the menu organization
            auth : { privilege : 'report.BrandSalesAffinity' },
            requireTerms:true
          },
          template : '<ui-view></ui-view>'
        })
        .state('brandReports.all', {
          url : '/all',
          data:{
            title:'Brand Report',
            path:'brand/all'
          },
          templateUrl : 'Brand/BrandReports.tmpl.html',
          controller : 'BrandReportsCtrl as vm'
        })
        .state('brandReports.BrandAffinity', {
          url : '/BrandAffinity?{brandKey}&timeFrame&focusDepartment&focusCategory&affinityDepartment&affinityCategory&{pageNumber:int}&{pageSize:int}&transaction&region',
          params : {
            pageNumber : 0,
            pageSize : 100 // default page size
          },
          data:{
            title: 'Brand Purchase Affinity',
            path:'brand/BrandAffinity'
          },
          templateUrl : 'Brand/BrandAffinity.tmpl.html',
          controller : 'BrandAffinityCtrl as vm',
          resolve : {
            selectedBrandKey: function(BrandReports, $stateParams){
              return BrandReports.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey){
                $stateParams.brandKey = selectedBrandKey;
                return selectedBrandKey;
              });
            },
            filters: function (BrandReports, $stateParams, activityRegion, selectedBrandKey) {
                return activityRegion(function() {
                  return BrandReports.getBrandAffinityFilters(selectedBrandKey)
                },$stateParams.transaction, $stateParams.region);
            },
            reportData : function (BrandReports, BrandAffinityTimeFrames, $stateParams, filters, selectedBrandKey) {
              if($stateParams.timeFrame == null) $stateParams.timeFrame = BrandAffinityTimeFrames[1];
                var transaction = filters.getSelected();
                var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
                return BrandReports.getBrandAffinity(selectedBrandKey, $stateParams.timeFrame, $stateParams.focusDepartment,
                    $stateParams.focusCategory, $stateParams.affinityDepartment, $stateParams.affinityCategory,
                    region, transaction && transaction.getLabel(), 100);
            },
            focusHierarchies : function (BrandReports, $stateParams, filters, selectedBrandKey) {
                var transaction = filters.getSelected();
                return BrandReports.findFocusHierarchies(selectedBrandKey, transaction && transaction.getLabel()).then(function (focusHierarchies) {
                  return _(focusHierarchies).filter(function (o) {
                    // Not including Baby, Girls, Boys or UnisexKids
                    return BrandReports.filterBrandCategories(o);
                  }).value();
                });
            },
            affinityHierarchies : function (BrandReports, $stateParams, filters, selectedBrandKey) {
                var transaction = filters.getSelected();
                return BrandReports.findAffinityHierarchies(selectedBrandKey, $stateParams.focusDepartment,
                    $stateParams.focusCategory, transaction && transaction.getLabel()).then(function (affinityHierarchies) {
                  return _(affinityHierarchies).filter(function (o) {
                    // Not including Baby, Girls, Boys or UnisexKids
                    return BrandReports.filterBrandCategories(o);
                  }).value();
                });
            },
            pricePointData : function (BrandReports, $stateParams, filters, selectedBrandKey) {
                var transaction = filters.getSelected();
                var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
                return BrandReports.getPricePointData(selectedBrandKey, $stateParams.timeFrame,
                    $stateParams.focusDepartment, $stateParams.focusCategory, $stateParams.affinityDepartment,
                    $stateParams.affinityCategory, region, transaction && transaction.getLabel());
            },
            brands : function (BrandReports) {
              return BrandReports.findUserBrandNames();
            },
            itemCount : function (BrandReports, $stateParams, filters, selectedBrandKey) {
                var transaction = filters.getSelected();
                var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
                return BrandReports.getPurchaseBrandItemCount(selectedBrandKey, $stateParams.timeFrame, $stateParams.focusDepartment,
                    $stateParams.focusCategory, $stateParams.affinityDepartment, $stateParams.affinityCategory,
                    region, transaction && transaction.getLabel());
            },
            aggregationLogDetails: function(BrandReports) {
              return BrandReports.getDashboardAggregationLogDetails('BrandSalesAffinity')
            }
          }
        })
  }

})();